import React from 'react';

const IndexContents = () => (
  <section className="index-contents">
    블로그는 있어야겠고 만들기는 귀찮고 지구야 멸망해라
  </section>
);

export default IndexContents;
